import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { AWS_CONFIG } from "../config/config";

// Shared across all HttpClient instances so concurrent 401s from
// parallel requests trigger a single logout/redirect.
let isHandlingAuthError = false;

export abstract class HttpClient {
  protected readonly instance: AxiosInstance;

  expiredCallback: any;

  protected constructor(baseURL: string, expiredTokenCb: (redirect:boolean)=>void) {
    this.instance = axios.create({
      baseURL,
      timeout: 300000,
      timeoutErrorMessage: "Request time out",
    });
    this.expiredCallback = expiredTokenCb
    this.initializeRequestInterceptor();
    this.initializeResponseInterceptor();
  }

  private initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this.handleRequest);
  };

  private initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(
      this.handleResponse,
      this.handleError
    );
  };

  // eslint-disable-next-line class-methods-use-this
  private handleRequest = async (
    config: AxiosRequestConfig
  ): Promise<AxiosRequestConfig> => {
    const token = localStorage.getItem("idToken");
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = `Bearer ${token}`;

    // ==================================================================
    // At the moment this logic doesn't work (initialization order issue)
    // ==================================================================
    // const token = await getData("idToken");

    // return {
    //   ...config,
    //   headers: {
    //     ...config.headers,
    //     authorization: `Bearer ${token}`,
    //   },
    // };
    // ==================================================================
    // ==================================================================
    return config; // TODO: remove when the code above is uncomment
  };

  // eslint-disable-next-line class-methods-use-this
  private handleResponse = (response: AxiosResponse) => response;

  protected handleError = (error: any) => {
    // Auto-logout on any 401 (expired, invalid or revoked session)
    if (
      axios.isAxiosError(error) &&
      error.response?.status === 401 &&
      !isHandlingAuthError
    ) {
      isHandlingAuthError = true;

      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("idToken");

      this.expiredCallback();

      // Reset in case the callback didn't navigate away
      setTimeout(() => {
        isHandlingAuthError = false;
      }, 1000);
    }

    return Promise.reject(error);
  };
}
